/* eslint-disable max-len */

import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const IconCampaignOptions: FC<Props> = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M6.25005 11.2637C5.88761 11.2637 5.5938 11.5684 5.5938 11.9443C5.5938 12.3201 5.88761 12.6248 6.25005 12.6248H13.75C14.1125 12.6248 14.4063 12.3201 14.4063 11.9443C14.4063 11.5684 14.1125 11.2637 13.75 11.2637H6.25005Z"
      fill="#272756"
    />
    <path
      d="M5.5938 14.8609C5.5938 14.4851 5.88761 14.1804 6.25005 14.1804H11.875C12.2375 14.1804 12.5313 14.4851 12.5313 14.8609C12.5313 15.2368 12.2375 15.5415 11.875 15.5415H6.25005C5.88761 15.5415 5.5938 15.2368 5.5938 14.8609Z"
      fill="#272756"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.3125 5.13889C5.3125 4.60195 5.73223 4.16667 6.25 4.16667H13.75C14.2678 4.16667 14.6875 4.60195 14.6875 5.13889V9.02778C14.6875 9.56472 14.2678 10 13.75 10H6.25C5.73223 10 5.3125 9.56472 5.3125 9.02778V5.13889ZM6.625 8.63889V5.52778H13.375V8.63889H6.625Z"
      fill="#272756"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 3.19444C2.5 2.12056 3.33947 1.25 4.375 1.25H15.625C16.6605 1.25 17.5 2.12056 17.5 3.19444V16.8056C17.5 17.8794 16.6605 18.75 15.625 18.75H4.375C3.33947 18.75 2.5 17.8794 2.5 16.8056V3.19444ZM4.375 2.61111H15.625C15.9357 2.61111 16.1875 2.87228 16.1875 3.19444V16.8056C16.1875 17.1277 15.9357 17.3889 15.625 17.3889H4.375C4.06434 17.3889 3.8125 17.1277 3.8125 16.8056V3.19444C3.8125 2.87228 4.06434 2.61111 4.375 2.61111Z"
      fill="#272756"
    />
  </svg>
);
